import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useState } from 'react';
import { Bubble, Card } from 'tea-component';

import './index.scss';
export default function CardSlot(props: any) {
  // children:  插入内容
  // title: 标题这里字符串和dom元素都可以
  // activeTab: 当前选择tab
  // isEyes: 是否展示右侧的眼睛查看icon  默认flase不展示，  true的话展示
  // isDownload: 是否展示右侧的下载  默认flase不展示，  true的话展示
  // iconList: 右边的icon 不传的话只显示下载
  // isAction: 如果需要左边右边箭头可以点击去的 true ，默认flase， 可以不传
  // getChange：右边按钮点击事件
  // getEyes: 显示不显示事件按钮
  // onDownload： 下载事件按钮
  // className： 传的类名
  // style: 传入样式
  // getDetails 点击标题
  const {
    children,
    title,
    activeTab,
    isEyes,
    isDownload,
    iconList,
    isAction,
    getChange,
    getEyes,
    onDownload,
    className,
    style,
    getDetails,
  } = props;
  const [isShow, setIsShow] = useState(false);
  return (
    <>
      <Card className={`card-slot ${className}`} style={style}>
        {title || iconList ? (
          <Card.Body
            title={
              isAction ? (
                <div
                  className={
                    isAction ? 'card-slot-title-hover' : 'card-slot-title'
                  }
                  onClick={getDetails}
                >
                  <span>{title}</span>
                  <SvgIcon type="arrow-right" className="card-slot-icon" />
                </div>
              ) : (
                title
              )
            }
            operation={
              <div className="card-slot-flex">
                {isEyes ? (
                  <Bubble
                    closeOnScroll
                    dark
                    content={isShow ? '不显示' : '显示'}
                  >
                    <i
                      onClick={() => {
                        setIsShow(!isShow);
                        getEyes(isShow);
                      }}
                      className="card-slot-item"
                    >
                      <SvgIcon
                        className="card-slot-charicon"
                        type={isShow ? 'eyes-closed' : 'open-eyes'}
                      />
                    </i>
                  </Bubble>
                ) : null}
                {iconList?.map((e: any, i: any) => {
                  return (
                    <Bubble closeOnScroll content={e.context} dark key={i}>
                      <i
                        className={
                          e.icon == activeTab
                            ? 'card-slot-action'
                            : 'card-slot-item'
                        }
                        onClick={() => {
                          getChange(e.icon);
                        }}
                      >
                        <SvgIcon type={e.icon} className="card-slot-charicon" />
                      </i>
                    </Bubble>
                  );
                })}
                {isDownload ? (
                  <Bubble closeOnScroll dark>
                    <i className="card-slot-char" onClick={onDownload}>
                      <SvgIcon type="download" className="card-slot-charicon" />
                    </i>
                  </Bubble>
                ) : null}
              </div>
            }
          >
            {children ? children : <div className="line-text">图表占位</div>}
          </Card.Body>
        ) : (
          <Card.Body>{children}</Card.Body>
        )}
      </Card>
    </>
  );
}
